/*
  src/redux/kpis/constants.js

  Created by erikchristensen on 11/03/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

function createConstant(action){
  return ['portal', 'kpis', action].join('/');
}

export const DASHBOARD_KPIS_REQUESTED = createConstant('DASHBOARD_KPIS_REQUESTED');
export const DASHBOARD_KPIS_LOADED = createConstant('DASHBOARD_KPIS_LOADED');
export const DASHBOARD_KPIS_FAILED_TO_LOAD = createConstant('DASHBOARD_KPIS_FAILED_TO_LOAD');

export const AGENCY_KPIS_REQUESTED = createConstant('AGENCY_KPIS_REQUESTED');
export const AGENCY_KPIS_LOADED = createConstant('AGENCY_KPIS_LOADED');
export const AGENCY_KPIS_FAILED_TO_LOAD = createConstant('AGENCY_KPIS_FAILED_TO_LOAD');

export const BRAND_KPIS_REQUESTED = createConstant('BRAND_KPIS_REQUESTED');
export const BRAND_KPIS_LOADED = createConstant('BRAND_KPIS_LOADED');
export const BRAND_KPIS_FAILED_TO_LOAD = createConstant('BRAND_KPIS_FAILED_TO_LOAD');

export const CAMPAIGN_KPIS_REQUESTED = createConstant('CAMPAIGN_KPIS_REQUESTED');
export const CAMPAIGN_KPIS_LOADED = createConstant('CAMPAIGN_KPIS_LOADED');
export const CAMPAIGN_KPIS_FAILED_TO_LOAD = createConstant('CAMPAIGN_KPIS_FAILED_TO_LOAD');

export const ALL_CAMPAIGN_KPIS_REQUESTED = createConstant('ALL_CAMPAIGN_KPIS_REQUESTED');
export const ALL_CAMPAIGN_KPIS_LOADED = createConstant('ALL_CAMPAIGN_KPIS_LOADED');
export const ALL_CAMPAIGN_KPIS_FAILED_TO_LOAD = createConstant('ALL_CAMPAIGN_KPIS_FAILED_TO_LOAD');



// WEBPACK FOOTER //
// ./src/shared/redux/kpis/constants.js